import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PoDialogService, PoDynamicFormField, PoLookupColumn, PoSelectOption } from '@po-ui/ng-components';
import { Cliente, getClienteDefault } from 'src/app/interface/cliente';
import { MunicipioIBGE } from 'src/app/interface/municpio-ibge';
import { AuthService } from 'src/app/service/auth.service';
import { CEPService } from 'src/app/service/cep-service';
import { ClienteService } from 'src/app/service/cliente-service';
import { MunicipioIBGEService } from 'src/app/service/municipio-ibge-service';
import { UtilService } from 'src/app/service/util';
import { getProcessoCadastroRevisaoClienteDefault, ProcessoCadastroRevisaoCliente } from '../../../interface/processo-revisao-cadastro-cliente';
import { ProcessoCadastroService } from 'src/app/administrativo/service/processo-cadastro';

@Component({
  selector: 'app-revisao-cadastro-cliente-editar',
  templateUrl: './revisao-cadastro-cliente-editar.component.html',
  styleUrls: ['./revisao-cadastro-cliente-editar.component.css']
})
export class RevisaoCadastroClienteEditarComponent implements OnInit {

  chave: string;
  tenantid: string;
  bloqueiaConfirmar: boolean;
  clienteDto: ProcessoCadastroRevisaoCliente;
  clienteOriginal: Cliente;
  listaEstado: Array<PoSelectOption>;

  advancedMunicipioIBGEFilters: Array<PoDynamicFormField>;
  columnsMunicipioIBGEFilters: Array<PoLookupColumn>;
  fieldFormaterMunicipioIBGEFilters: ((value: MunicipioIBGE) => string);

  constructor(
    private route: ActivatedRoute,
    public clienteService: ClienteService,
    public processoCadastroService: ProcessoCadastroService,
    public municipioIBGEService: MunicipioIBGEService,
    private poDialog: PoDialogService,
    private authService: AuthService,
    public utilService: UtilService,
    public cepService: CEPService,
  ) {
    this.chave = '';
    this.tenantid = '';
    this.bloqueiaConfirmar = true;
    this.clienteDto = getProcessoCadastroRevisaoClienteDefault();
    this.clienteOriginal = getClienteDefault();
    this.listaEstado = utilService.getListaEstados();

    sessionStorage.clear();


    this.advancedMunicipioIBGEFilters = this.municipioIBGEService.getAdvancedFilter();
    this.columnsMunicipioIBGEFilters = this.municipioIBGEService.getColumnsFilter();
    this.fieldFormaterMunicipioIBGEFilters = this.municipioIBGEService.getFieldFormater;
  }

  @ViewChild('formCadastroCliente', { static: true }) formCadastroCliente!: NgForm;

  ngOnInit(): void {

    this.authService.autoLogin('portal', '9bLkksY,Q6').then(() => {
      this.route.params.subscribe((params) => {
        if ('chave' in params) {
          this.chave = params['chave'];

          sessionStorage.setItem('CUSRID', '000268');
          sessionStorage.setItem('tenantid', '01,01');

          this.processoCadastroService.getClienteSA1(this.chave).subscribe(clienteDto => {
            this.clienteDto = { ...clienteDto };
            this.clienteOriginal = { ...clienteDto.cliente };
            this.municipioIBGEService.estado = this.clienteDto.cliente.CA1EST;
          }, (e) => {
            this.poDialog.alert({
              title: 'ATENÇÃO',
              message: 'CHAVE INVÁLIDA OU FORMULÁRIO JÁ PREENCHIDO ANTERIORMENTE. CASO TENHA DÚVIDA, FAVOR EM CONTATO COM SOLIDA.',
              ok: () => this.redirecionar()
            });

          });
        }
      })
    })


  }

  openModalConfirmar() {
    this.poDialog.confirm({
      title: 'Confirmar Cadastro',
      message: 'Deseja realmente confirmar os dados apresentados?',
      confirm: () => this.salvar()
    });
  }

  salvar() {

    this.clienteDto.COBSERVACAO = `CONFIRMACAO FORNECEDOR - ${this.clienteDto.COBSERVACAO}`;

    this.processoCadastroService.postClienteTemporario(this.clienteDto).subscribe(() => {
      this.poDialog.alert({
        title: 'Dados Enviados',
        message: 'Dados enviados com sucesso! Agradecemos pela parceria de sempre.',
        ok: () => this.redirecionar()
      });

    });

  }

  redirecionar() {
    window.location.href = 'http://www.solidabrasil.com.br';
  }

  validForm(): boolean {
    return !(this.formCadastroCliente.valid);
  }

  alteraCep() {
    this.cepService.getObjectByValue(this.clienteDto.cliente.CA1CEP).subscribe(cep => {
      if (cep.cep) {
        this.clienteDto.cliente.CA1END = `${cep.logradouro.toUpperCase()}, `;
        this.clienteDto.cliente.CA1BAIRRO = cep.bairro.toUpperCase();
        this.clienteDto.cliente.CA1EST = cep.uf;
        this.clienteDto.cliente.CA1COD_MUN = cep.ibge.substring(2, 7);
        this.municipioIBGEService.estado = cep.uf;
      } else {
        this.clienteDto.cliente.CA1END = '';
        this.clienteDto.cliente.CA1BAIRRO = '';
        this.clienteDto.cliente.CA1EST = '';
        this.clienteDto.cliente.CA1COD_MUN = '';
        this.municipioIBGEService.estado = '';
      }
    });

  }

  municipioIBGESelecionado(row: MunicipioIBGE) {
    this.clienteDto.cliente.CA1MUN = row.CCC2MUN;
  }



}
